import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

import "swiper/css";

const videosBlocks = document.querySelectorAll('[data-block="videos"]');

if (videosBlocks.length) {
  videosBlocks.forEach((videos) => {
    const sldierVideos = videos.querySelector('[data-slider="videos"]');
    const sldierReviews = videos.querySelector('[data-slider="reviews"]');
    const pagination = videos.querySelector(".slider-pagination");
    const btnNext = videos.querySelector(".slider-btn--next");
    const btnPrev = videos.querySelector(".slider-btn--prev");

    new Swiper(sldierVideos, {
      speed: 600,
      slidesPerView: 1,
      spaceBetween: 20,
      grabCursor: true,
      pagination: {
        el: pagination,
        clickable: true,
      },
      navigation: {
        nextEl: btnNext,
        prevEl: btnPrev,
      },
      breakpoints: {
        992: {
          slidesPerView: 3,
          spaceBetween: 22,
        },
        1200: {
          slidesPerView: 4,
        },
        1400: {
          slidesPerView: 5,
        },
      },
      modules: [Navigation, Pagination],
    });

    new Swiper(sldierReviews, {
      speed: 600,
      slidesPerView: 1,
      spaceBetween: 20,
      grabCursor: true,
      pagination: {
        el: pagination,
        clickable: true,
      },
      navigation: {
        nextEl: btnNext,
        prevEl: btnPrev,
      },
      breakpoints: {
        992: {
          slidesPerView: 2,
        },
        1200: {
          slidesPerView: 3,
        },
      },
      modules: [Navigation, Pagination],
    });
  });
}
